import { ConstrainedUserAttDefs } from '../../types/ModelTypes'
import {} from '../../types/DatastoreTypes'
import { CoreApplicationObjectType, MapLike, Position, DynamicIndexObjectType } from '@iotv/iotv-v3-types'
import { UserAttributeDefs } from '../../types//ModelTypes'
import { GeoModelCommon } from './GeoModelCommon'

const debug = !process.env.AWS_SESSION_TOKEN && false

const typeName = 'NamedPoint'

export interface INamedPoint extends CoreApplicationObjectType {
  property?: string
  locale?: string
  subLocale?: string
  placementPosition?: string
  location?: Position
  locationCalculated?: Position
  mapDisplayProps?: INMFMapDisplayProps
  receptionPoints?: Position[]
}

export interface INMFMapDisplayProps {
  style: MapLike<any>
  displayAttributes: MapLike<any>
  displayOnMap: boolean
}

type NamePointKeys = keyof CoreApplicationObjectType

class NamedPoint extends GeoModelCommon implements INamedPoint, DynamicIndexObjectType {
  constructor({ name, ...ob }: INamedPoint & { name: string }) {
    super({ ...ob })
  }
  property?: string
  locale?: string
  subLocale?: string
  locationCalculated?: Position
  mapDisplayProps?: INMFMapDisplayProps
  placementPosition?: string
  receptionPoints?: Position[]

  get name() {
    return [
      this.property ?? 'UnknownProperty',
      this.locale ?? 'UnknownLocale',
      this.subLocale ?? 'UnknownSubLocale',
      this.placementPosition ?? 'UnknownPlacementPoistion',
      this.dsk ?? this.id,
    ].join(':')
  }

  set name(name: string) {
    const parts = name.split(':')
    const keys = ['property', 'locale', 'subLocale', 'placementPosition', 'id']

    if (parts.length > 1) {
      parts.forEach((part, i) => {
        if (keys[i]) {
          this[keys[i]] = part
        }
      })
    }
  }

  get location_calculated_lat() {
    return this.locationCalculated?.lat ?? 0
  }
  set location_calculated_lat(val: number) {
    if (!this.locationCalculated) Object.assign(this, { locationCalculated: {} })
    if (this.locationCalculated) this.locationCalculated.lat = val
  }

  get location_calculated_lng() {
    return this.locationCalculated?.lng ?? 0
  }
  set location_calculated_lng(val: number) {
    if (!this.locationCalculated) Object.assign(this, { locationCalculated: {} })
    if (this.locationCalculated) this.locationCalculated.lng = val
  }

  get display_on_map() {
    return this.mapDisplayProps?.displayOnMap
  }

  set display_on_map(yn: boolean | undefined) {
    if (!this.mapDisplayProps) Object.assign(this, { mapDisplayProps: {} })
    if (this.mapDisplayProps?.displayOnMap) this.mapDisplayProps.displayOnMap = yn ?? false
  }

  get style() {
    return this.mapDisplayProps?.style ? JSON.stringify(this.mapDisplayProps.style, null, 1) : undefined
  }

  set style(styleJson: string | undefined) {
    if (styleJson) {
      let parsedStyle: MapLike<any> | undefined
      try {
        parsedStyle = JSON.parse(styleJson)
      } catch (e) {
        console.log('Error parsing', styleJson)
      }

      if (!this.mapDisplayProps) Object.assign(this, { mapDisplayProps: {} })
      if (this.mapDisplayProps && parsedStyle) this.mapDisplayProps.style = parsedStyle
    }
  }

  get display_attributes() {
    return this.mapDisplayProps?.displayAttributes ? JSON.stringify(this.mapDisplayProps.displayAttributes, null, 1) : undefined
  }

  set display_attributes(attJson: string | undefined) {
    if (attJson) {
      let parseAtts: MapLike<any> | undefined
      try {
        parseAtts = JSON.parse(attJson)
      } catch (e) {
        console.log('Error parsing', attJson)
      }

      if (!this.mapDisplayProps) Object.assign(this, { mapDisplayProps: {} })
      if (this.mapDisplayProps && parseAtts) this.mapDisplayProps.displayAttributes = parseAtts
    }
  }

  getUserAttributes(): ConstrainedUserAttDefs<INamedPoint> & UserAttributeDefs {
    const { type, name, location_lat, location_lng, ...others } = super.getUserAttributes()

    return {
      type,
      name,
      location_lat,
      location_lng,
      property: {
        type: 'String',
      },
      locale: {
        type: 'String',
      },
      subLocale: {
        type: 'String',
      },
      placementPosition: {
        type: 'String',
        label: 'Place',
      },
      location_calculated_lat: {
        type: 'Number',
        precision: 5,
        label: 'Lat_c',
      },
      location_calculated_lng: {
        type: 'Number',
        precision: 5,
        label: 'Lng_c',
      },
      display_on_map: {
        type: 'Boolean',
        label: 'Disp?',
      },
      style: {
        type: 'String',
      },
      display_attributes: {
        type: 'String',
        label: 'Atts',
      },
    }
  }
}

export { NamedPoint }
